var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3208_104552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9024 15.0976C4.40402 14.5992 4.40402 13.7912 4.90241 13.2928L8.19529 10L4.9024 6.70714C4.40402 6.20877 4.40403 5.40074 4.90241 4.90236C5.40079 4.404 6.2088 4.40401 6.70717 4.90238L10 8.19525L13.2929 4.90237C13.7913 4.40401 14.5993 4.40401 15.0977 4.90239C15.596 5.40075 15.596 6.20875 15.0977 6.70711L11.8048 10L15.0976 13.2928C15.596 13.7912 15.596 14.5992 15.0977 15.0976C14.5993 15.596 13.7913 15.596 13.2929 15.0976L10 11.8048L6.70719 15.0976C6.20881 15.596 5.40078 15.596 4.9024 15.0976Z",
    fill: "#A4A4A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3208_104552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.3184c312.svg";
export { ForwardRef as ReactComponent };